import React from 'react';
import { FaGift, FaUserFriends, FaRupeeSign } from 'react-icons/fa';

const ReferEarn = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Refer & <span className="text-orange-500">Earn</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 text-center">
          <FaGift className="text-6xl text-orange-500 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Invite Friends, Get Rewards</h2>
          <p className="text-gray-600 mb-6">Share your unique referral code with friends. When they make their first purchase, you both get ₹500 off!</p>
          <div className="bg-orange-50 p-4 rounded-xl inline-block">
            <span className="text-2xl font-bold text-orange-600">BRframes50</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <FaUserFriends className="text-4xl text-orange-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">How it works</h3>
            <ol className="list-decimal list-inside text-gray-600 space-y-2">
              <li>Share your referral code</li>
              <li>Friend signs up and orders</li>
              <li>You both get ₹500 credit</li>
            </ol>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <FaRupeeSign className="text-4xl text-orange-500 mb-4" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Terms</h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Minimum order value ₹1000</li>
              <li>Valid for new users only</li>
              <li>Credits expire in 3 months</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferEarn;